module.exports = __webpack_public_path__ + "img/img2.0c5c4f92.jpg";